

























































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';
import FlaggedCommentDetailsFormModal from '@/web/views/admin/community/FlaggedCommentDetailsFormModal';
import { mapGetters } from 'vuex';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'CommunityFlaggedComments',
  components: {
    TopNav,
  },
  data() {
    return {
      tableFields: [
        {
          name: 'member_name',
          title: this.$t('COMMUNITY.TABLE.MEMBER_NAME') as string,
        },
        {
          name: 'comment_preview',
          title: this.$t('COMMUNITY.TABLE.COMMENT_PREVIEW') as string,
          cssClass: 'text-dark',
        },
        {
          name: 'flags',
          title: this.$t('COMMUNITY.TABLE.FLAGS') as string,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
    }),
  },
  methods: {
    async deleteFlaggedComment(comment) {
      try {
        await this.$store.dispatch('community/deleteFlaggedComment', {
          commentId: comment.id,
          isStudio: true,
        });
        comment.deleted = true;
        this.$refs.commentsTable.refresh();
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
    openCommentDetailsModal(comment) {
      this.$modal.show(FlaggedCommentDetailsFormModal, {
        comment,
        confirm: this.deleteFlaggedComment,
      });
    },
    viewProfile(data) {
      if (this.isStudio(data)) return;
      const route = this.$router.resolve({
        name: 'student-community-profile-view',
        params: {
          id: data?.user?.id,
          studio_url: this.teacherStudioUrl,
        },
      });
      const routeUrl = route.href.replaceAll(`${this.teacherStudioUrl}/`, '');
      const url = getStudentViewURL(
        this.teacherStudioUrl,
        routeUrl,
        this.teacherMagicCode
      );

      window.open(url, '_blank');
    },
    isStudio(data) {
      return data?.additional_data?.user_role === 'studio';
    },
  },
});
